import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { CustomErrorHandler } from './../app/infrastructure/infrastructure-services/common/custom-error-handler';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './services/interceptors/error.interceptor';
import { JwtInterceptor } from './services/interceptors/request.interceptor';
import { ResponseInterceptor } from './services/interceptors/response.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MasterLayoutModule } from './master-layout/master-layout.module';
import { LoginModuleModule } from './login-layout/login-module.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InfrastructureModule } from './infrastructure/infrastructure.module';
import { MatIconModule } from '@angular/material/icon';
//import {MatCheckboxModule} from '@angular/material/checkbox';

import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table'
import { MatInputModule } from '@angular/material/input';
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  POSITION,
} from "ngx-ui-loader";
import { GenericCflViewComponent } from './infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { MatTabsModule } from '@angular/material/tabs';

import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { BreadcrumbModule } from 'angular-crumbs';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from './shared/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TextMaskModule } from 'angular2-text-mask';
import {CdkTableModule} from '@angular/cdk/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { I18nModule } from './i18n.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CallbackComponent } from './callback/callback.component';

// import { NgxMaskModule, IConfig } from 'ngx-mask'

//loader
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  //fgsColor:'blue',
  bgsColor: "red",
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  // bgsType: SPINNER.rectangleBounce, // background spinner type
  // fgsType: SPINNER.ballSpinClockwise, // foreground spinner type
  // pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  // pbThickness: 5, // progress bar thickness,
  hasProgressBar: false,
  logoPosition: "center-center",
  logoSize: 120,
 // logoUrl: "assets/images/msmeLoaderLogo.jpeg",
};

//indexedDB
const dbConfig: DBConfig = {
  name: 'MsmeDB',
  version: 2,
  objectStoresMeta: []
};

@NgModule({

  declarations: [
    AppComponent,
     CallbackComponent,
    GenericCflViewComponent],
  imports: [
     TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false,
    }),
    BrowserModule,
    AppRoutingModule,
    InfrastructureModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSidenavModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatToolbarModule,
    RouterModule,
    MasterLayoutModule,
    LoginModuleModule,
    MatGridListModule,
    MatListModule,
    MatFormFieldModule,
    MatIconModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatRadioModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTableModule,
    MatInputModule,
    MatTabsModule,
    TextMaskModule,
    MatInputModule,
    BreadcrumbModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    SharedModule,
    FeatherModule,
    FeatherModule.pick(allIcons),
    MatMenuModule,
    InfiniteScrollModule,
    TranslateModule,
    MatTooltipModule,
    MatPaginatorModule,
    I18nModule
  ],
  exports: [
    BrowserModule,
    BreadcrumbModule,
    BrowserAnimationsModule,
    CdkTableModule,
  ],
  providers: [
  { provide: ErrorHandler, useClass: CustomErrorHandler},
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
  { provide: MatDialogRef, useValue: {} },
  { provide: MAT_DIALOG_DATA, useValue: {} }],
  bootstrap: [AppComponent], 
   
})
export class AppModule { }
export function translateLoaderFactory(httpClient: HttpClient) {
  // return new TranslateHttpLoader(httpClient);
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

